var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-about",on:{"click":function($event){return _vm.btnClickHandler()}}},[_c('btn-blue',{attrs:{"size":"small"}},[_c('span',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.$t('btn.about'))}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }